import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchExcursionConfig = async (
  { rootGetters, commit },
  { params, excursionId, queryParams }
) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getExcursionConfig(excursionId, params, queryParams);
  if (response) {
    commit('setExcursionConfig', response);
  }
  return response;
};
